import { useContext } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import { SET_SHOW_HIDE_WIRE_POPUP, WireContext } from '../context/context'
import WireForm from './WireForm'

const WireFormModal = (props) => {
  const [state, dispatch] = useContext(WireContext)

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: SET_SHOW_HIDE_WIRE_POPUP,
          data: false,
        })
      }}
      show={state?.showWireFormPopup}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white'}>Wire</ModalHeader>
      <ModalBody>
        <WireForm
          onClose={() => {
            props.onClose()
          }}
        />
      </ModalBody>
    </Modal>
  )
}

export default WireFormModal
